import type { AutoGeneratorForFormModel } from "@/components/features/_model";

import type { DiscountLongTermInputZodSchemaType } from "./validation-schema";

const _excludeKeys = [
	"hotelID",
	"discountID",
	"isUncancelable",
	"saleTypeForPlan",
	"saleTypeForTerm",
	"stayableDayOfTheWeek",
] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

export type DiscountLongTermStayFormModel = AutoGeneratorForFormModel<
	DiscountLongTermInputZodSchemaType,
	ExcludeKeys,
	undefined
>;
